import { VoiceDeviceState } from "@redotech/redo-support-common/support/voice/voice-types";
import { WorkScheduleAvailability } from "@redotech/redo-support-common/work-schedule/types";
import { memo } from "react";
import { RedoListItem } from "../../arbiter-components/list/redo-list";
import { StatusDotColor } from "../../arbiter-components/list/redo-list-item-lead";
import { Flex } from "../../flex";
import { Text } from "../../text";
import { StatusDot } from "./status-dot";

export const StatusText: Record<VoiceDeviceState, string> = {
  [VoiceDeviceState.AVAILABLE]: "Available",
  [VoiceDeviceState.IN_CALL]: "In Call",
  [VoiceDeviceState.UNAVAILABLE]: "Unavailable",
};

/** The one place availability turns into a dot colour. */
export const WorkScheduleAvailabilityToStatusColor = {
  [WorkScheduleAvailability.AVAILABLE]: "green",
  [WorkScheduleAvailability.BUSY]: "gray",
  [WorkScheduleAvailability.OFFLINE]: "red",
} as const satisfies Record<WorkScheduleAvailability, StatusDotColor>;

/** A registered-but-busy device reads busy, not its own third colour. */
export const VoiceDeviceStateToStatusColor = {
  [VoiceDeviceState.AVAILABLE]:
    WorkScheduleAvailabilityToStatusColor[WorkScheduleAvailability.AVAILABLE],
  [VoiceDeviceState.IN_CALL]:
    WorkScheduleAvailabilityToStatusColor[WorkScheduleAvailability.BUSY],
  [VoiceDeviceState.UNAVAILABLE]:
    WorkScheduleAvailabilityToStatusColor[WorkScheduleAvailability.OFFLINE],
} as const satisfies Record<VoiceDeviceState, StatusDotColor>;

export function statusToListItem(
  status: VoiceDeviceState,
): RedoListItem<VoiceDeviceState> {
  return {
    id: status,
    text: StatusText[status],
    value: status,
    type: "text",
    leadingItem: {
      type: "status",
      color: VoiceDeviceStateToStatusColor[status],
    },
  };
}

export const PhoneWidgetStatus = memo(function PhoneWidgetStatus({
  status,
}: {
  status: VoiceDeviceState;
}) {
  return (
    <Flex align="center">
      <StatusDot color={VoiceDeviceStateToStatusColor[status]} />
      <Text fontSize="xs">{StatusText[status]}</Text>
    </Flex>
  );
});
